import { useCallback } from "react";

import { useLocalStorage } from "usehooks-ts";

const RECENT_WORKSPACES_KEY = "recentWorkspaces";
const MAX_RECENT_WORKSPACES = 5;

export type RecentWorkspace = {
  workspaceId: string;
  workspaceName: string;
  orgId: string;
  orgName: string;
};

export const useRecentWorkspaces = () => {
  const [recentWorkspaces, setRecentWorkspaces] = useLocalStorage<
    RecentWorkspace[]
  >(RECENT_WORKSPACES_KEY, []);

  const addRecentWorkspace = useCallback(
    (entry: RecentWorkspace) => {
      setRecentWorkspaces((prev) => {
        const filtered = prev.filter(
          (ws) => ws.workspaceId !== entry.workspaceId,
        );
        return [entry, ...filtered].slice(0, MAX_RECENT_WORKSPACES);
      });
    },
    [setRecentWorkspaces],
  );

  return { recentWorkspaces, addRecentWorkspace };
};
